import Flickity from 'flickity'
import { isNull } from '../misc/Utils'

export default class ArticleSlider {
    constructor() {
        this.cacheDom()
        this.initialize()
    }

    cacheDom() {
        this.flkty = []
        this.slider = document.querySelectorAll('.article-layout-image-slider')
    }

    initialize() {
        if (isNull(this.slider)) {
            return
        }

        Array.prototype.forEach.call(this.slider, (element, i) => {
            const slides = element.querySelector('.slides')
            const arrows = element.querySelectorAll('.slides-arrows')
            let caption = element.querySelector('.slides-caption')
            const items = element.querySelectorAll('.slides-item')

            this.flkty[i] = new Flickity(slides, {
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: false,
                wrapAround: true,
                autoPlay: false,
                adaptiveHeight: true,
                on: {
                    ready: () => {
                        caption.innerHTML = items[0].getAttribute('data-caption')
                    },
                    change: (index) => {
                        caption.innerHTML = items[index].getAttribute('data-caption')
                    },
                },
            })

            Array.prototype.forEach.call(arrows, (arrow) => {
                arrow.addEventListener('click', this.handleArrowClick.bind(this, i))
            })
        })
    }

    handleArrowClick(i, event) {
        if (event.target.classList.contains('next')) {
            this.flkty[i].next(true, false)
        } else {
            this.flkty[i].previous(true, false)
        }
    }
}
